import { forwardRef } from 'react';
import { BlockContent } from './BlockContent';

export const Item = forwardRef(({ ...props }, ref) => {
  return (
    <div {...props} ref={ref} className="dragblock">
      <button className="drag-thumb"></button>
      <BlockContent title={props.id} />
    </div>
  );
});
